import {observable, action, runInAction} from 'mobx';
import Api from '../../services/api';
import {IDefaultDestination} from "../../types/IDefaultDestination";

class DefaultDestinationsStore {
    constructor() {
        this.getDefaultDestinations()
    }

    @observable public defaultDestinations:IDefaultDestination[] = [];

    @action
    public getDefaultDestinations = async () => {
        try {
            const defaultDestinations = await Api.getDefaultDestinations();
            runInAction(() => {
                this.defaultDestinations = defaultDestinations;
            });
        } catch(e) {
            console.log(e);
        }
    };
}

const defaultDestinationsStore = new DefaultDestinationsStore();

export default defaultDestinationsStore;
